import { post } from '../utils/api';

export type StyleCategory = Partial<{
  stt: number;
  businessProductGroupCode: string;
  businessProductGroupName: string
  id: string;
  productClassCode: string
  productClassName: string
  productGroupCode: string
  productGroupName: string
  productStyleCode: string
  productStyleName: string
  actived: boolean
}>;

export type DataResponse = {
  data: Array<StyleCategory>;
  message: string;
  isSuccess: boolean;
  //tong so phan tu trong mang
  recordsTotal: number;
  //so ket qua trong 1 trang
  resultsCount: number;
  //so trang
  pagesCount: number;
};

// interface cua Test Target
// khoi tao cac phuong thuc

export interface IStyleCategoryServices {
  getList(data: any): Promise<DataResponse>;
}

//ham khoi tao cac phuong thuc cua Test Target
export function createStyleCategoryServices(): IStyleCategoryServices {
  return {
    getList: async (data: any): Promise<DataResponse> => {
      return (await post(`MasterData/Category/search-product-style`, data)).data;
    },
  };
}
